module.exports = "<span class=\"tag {{tp}}\"\n    [class.primary]=\"isPrimary\"\n    [class.secondary]=\"isSecondary\"\n    (click)='switch($event)'>\n    <span class='number'>{{number}}</span>\n    <span [innerHTML]='name'></span>\n  </span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tag-sort/tag-sort.component.html
// module id = 445
// module chunks = 0